var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PImportReports',{attrs:{"loading":_vm.loading,"import-reports":_vm.importReports,"error":_vm.error}})
}
var staticRenderFns = []

export { render, staticRenderFns }